import classNames from 'classnames';
import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';

import './TextCell.css';

export interface TextProps {
    capitalize?: boolean;
    cls?: string;
}

export class TextCell extends React.PureComponent<TextProps> {
    render() {
        const { children, capitalize, cls } = this.props;

        return (
            <div
                className={classNames(
                    cls,
                    Bem.cls({
                        block: 'text-cell',
                        mods: {
                            capitalized: Boolean(capitalize)
                        }
                    })
                )}
            >
                {children || '–'}
            </div>
        );
    }
}
